import React, { useEffect } from "react";
import MainLayout from "../../Main/MainLayout";
import IdbService from "../../Services/IDBService";
import utils from "../../Services/Utils";

export default function APIRequests() {
  const [requests, setRequests] = React.useState<any>();
  const [tag, setTag] = React.useState<any>("");
  useEffect(() => {
    let ref = IdbService.getDB()
      .collection("requests")
      // .where("createdAt", ">=", new Date(2022, 0, 6, 19, 33).getTime())
      // .where("createdAt", "<=", new Date(2022, 0, 6, 19, 41).getTime())
      .where("createdAt", "<=", Date.now() + 5000000)

      .orderBy("createdAt", "desc")
      .limit(50);
    if (tag) {
      ref = ref.where("request.tag", "==", tag);
    }

    let unsubscribe = ref.onSnapshot((ref) => {
      const lst = ref.docs.map((item) => ({
        ...item.data(),
        id: item.id,
      }));
      // console.log("lst", lst, new Date(2022, 0, 6, 19, 30).getTime());
      setRequests(lst);
    });
    return () => {
      unsubscribe();
    };
  }, [tag]);

  async function exportAsHtml(selected: boolean) {
    let cbs = Array.from(document.querySelectorAll("input[type=checkbox]"));
    if (selected) {
      cbs = Array.from(
        document.querySelectorAll("input[type=checkbox]:checked")
      );
    }
    if (cbs.length === 0) return alert("Nothing to export");
    let trHtml = cbs
      .map((item) => item.parentElement?.parentElement?.outerHTML)
      .join("\n");

    let html = `<table style="width:100%;" border="1" cellspacing="0"> <thead>
            <tr>
            <th>Operation No</th>
            <th>key Values</th>
            <th>Response</th>
            </tr>
            <tbody>
            ${trHtml}
            </tbody>
        </thead>`;

    try {
      throw new Error("firebas disabled");
      // const res = await IdbService.uploadHtmlToStorage(
      //   `requests_${Date.now()}.html`,
      //   html
      // );
      // console.log(res.ref.getDownloadURL());
      // const url = await res.ref.getDownloadURL();
      // if (url) window.open(url);
      // else alert("Can not create url");
    } catch (ex) {
      console.log(ex);
      utils.downloadFile(`requests_${Date.now()}.html`, html);
    }
  }

  return (
    <MainLayout containerProps={{ maxWidth: "xl" }} hideHeader>
      <button onClick={() => exportAsHtml(true)}>Export Selected</button>
      <button onClick={() => exportAsHtml(false)}>Export All</button>{" "}
      <select value={tag} onChange={(e) => setTag(e.target.value)}>
        <option value="">All</option>
        <option value="UAT">UAT</option>
        <option value="LIVE">Live</option>
        <option value="ERROR">Error Log</option>
      </select>
      <table
        style={{ width: "100%", border: "1" }}
        cellSpacing={0}
        // @ts-ignore
        border="1"
      >
        <thead>
          <tr>
            <th>Operation No</th>
            <th>key Values</th>
            <th>Response</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(requests) &&
            requests.map((item, idnex) => {
              // console.log(item);
              let tag = <span style={{ color: "orange" }}>UAT</span>;
              if (item?.request?.tag === "LIVE") {
                tag = <span style={{ color: "green" }}>Live</span>;
              }
              if (item?.request?.tag === "ERROR") {
                tag = <span style={{ color: "red" }}>Error</span>;
              }
              return (
                <tr key={item.id}>
                  <td style={{ width: 50 }}>
                    <input type="checkbox" className="selected" /> Export
                    <br />
                    <br />
                    {tag}
                    <br />
                    {item.request?.ClassJOperationIC}
                    <br />
                    <span style={{ color: "blue" }}>
                      {new Date(item.createdAt).toLocaleString()}
                    </span>
                  </td>
                  <td>
                    {/* {item.request?.KeyValues && (
                      <div style={{ maxWidth: 500, height: 250 }}>
                        <ObjectView obj={item.request?.KeyValues} />
                      </div>
                    )} */}
                    {item.request?.KeyValues && (
                      <textarea
                        style={{ width: "100%", height: 250 }}
                        defaultValue={JSON.stringify(
                          item.request?.KeyValues,
                          null,
                          4
                        )}
                      ></textarea>
                    )}
                  </td>

                  <td>
                    <textarea
                      style={{ width: "100%", height: 250 }}
                      defaultValue={JSON.stringify(item.response, null, 4)}
                    ></textarea>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </MainLayout>
  );
}

// function ObjectView({ obj }: { obj: any }) {
//   return (
//     <>
//       {Object.keys(obj).map((key) => {
//         const parsed = utils.tryJSONParse(obj[key]);
//         return (
//           <div>
//             <b>{key}:</b>
//             <span>{obj[key].toString()}</span>
//           </div>
//         );
//       })}
//     </>
//   );
// }
